import React from 'react';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd';

import {
  CmBox,
  CmCard,
  CmFlex,
  CmHelpterText,
  CmIconButton,
  CmLink,
  CmText,
} from '@/components/uiParts';
import { CloseIcon, DragHandleIcon } from '@/components/uiParts';
import { SearchItem } from '@/pages/menu-managements/services/searchItem';

type Props = {
  selectedItems: SearchItem[];
  targetOption: 'items' | 'categories' | 'option-groups';
  handleOnDragEnd: (result: DropResult) => void;
  handleDeleteDragItem: (itemId: string) => void;
};

export const MenuManagementDragItems: React.FC<Props> = ({
  selectedItems,
  targetOption,
  handleOnDragEnd,
  handleDeleteDragItem,
}): JSX.Element => {
  return (
    <>
      {selectedItems.length > 0 && (
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="search-items">
            {(provided) => (
              <ul {...provided.droppableProps} ref={provided.innerRef}>
                {selectedItems.map((item, index) => {
                  return (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      {...{ index }}
                    >
                      {(provided) => (
                        <li
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          <CmBox py="1">
                            <CmCard padding="2">
                              <CmFlex
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <CmFlex alignItems="center">
                                  <CmBox {...provided.dragHandleProps} mr="4">
                                    <DragHandleIcon
                                      aria-label="ドラッグ"
                                      mt="-4px"
                                    />
                                  </CmBox>
                                  <CmLink
                                    color="blue.500"
                                    to={`/menu-managements/${targetOption}/${item.id}/edit`}
                                  >
                                    <CmBox ml="2">
                                      <CmText>
                                        {item.title.translation.ja}
                                      </CmText>
                                      {item.memo !== null && (
                                        <CmHelpterText>
                                          {item.memo}
                                        </CmHelpterText>
                                      )}
                                    </CmBox>
                                  </CmLink>
                                </CmFlex>
                                {/*
                                 // @ts-ignore TS2590 */}
                                <CmIconButton
                                  aria-label="削除"
                                  cursor="pointer"
                                  onClick={() => {
                                    handleDeleteDragItem(item.id);
                                  }}
                                  icon={<CloseIcon />}
                                />
                              </CmFlex>
                            </CmCard>
                          </CmBox>
                        </li>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </>
  );
};
